import { connect } from 'react-redux';
import PersonData from './PersonData';
import { getUpdatePersonLoader } from '../../../../store/selectors/person.selectors';
import { updatePersonBegin } from '../../../../store/actions/person.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getUpdatePersonLoader(state);
    return { isLoading };
};

const mapDispatchToProps = {
    updatePerson: updatePersonBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(PersonData);
